export const ENTRYPOINT = import.meta.env.VITE_API_ENTRYPOINT;
